const getHiddenInputs = () => {
  // Very specific funtion that was requested by one dealer group
  const timestamp = document?.querySelector<HTMLInputElement>(
    'input[name="lw_hit_timestamp"]',
  )?.value;
  const ga = document?.querySelector<HTMLInputElement>('input[name="_ga"]')?.value;
  const combinedResult = timestamp && ga ? `${ga} ${timestamp}` : '';
  return combinedResult;
};

export default getHiddenInputs;
